import type { Account, AccountNumber, AccountSortingKey, Card } from '../../generated-types';

export * from './groupings';

export enum AccountCardType {
    ACCOUNT = 'ACCOUNT',
    CREDIT_CARD = 'CREDIT_CARD',
}

export interface AccountCardItem {
    alias?: string;
    accountNumber: AccountNumber;
    favorite?: boolean;
    sortKey?: AccountSortingKey;
    accountType: AccountCardType;
    account?: Account;
    card?: Card;
}
